import { createContext } from "react";
import type { PickerState } from "./PickerState";

export const pickerStateContext = createContext<
  PickerState<unknown> | undefined
>(undefined);
